import { render, staticRenderFns } from "./Pgd.vue?vue&type=template&id=13fba82e"
import script from "./Pgd.vue?vue&type=script&lang=js"
export * from "./Pgd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports